$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

  // General Message
  $('.generalmessage').prependTo('.header');
  $('.emailInputSubmit a').text("Email Sign-Up");
  $('.hours-buttton').clone().appendTo('.mobile-directions');
  $('#headerNav_uc_widgetContainer_ctl00_ctl00_ctl00_SearchBox1_tbx_searchBox').attr('placeholder', 'Search Website')

});

$(window).load(function () {
  $('.viewcart').clone().appendTo('.cart-mobile');


  setTimeout(() => {
    $(".socialNetworks .socialNetworkIconTwitter").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconFacebook").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconYoutube").attr('target', '_blank');
    $(".socialNetworks .socialNetworkIconInstagram").attr('target', '_blank');

  }, 1000)

});


